import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

type TCommissionConsentStepProps = {
    status: TFundingRequirementStatus;
};

export const CommissionConsentStep = ({
    status
}: TCommissionConsentStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.commission_consent_step.title"
                    defaultMessage="Acknowledge Introducer Commission"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 2 }}
                />
            }
            href="/funding-requirements/commission-consent"
            status={status}
            completedView={
                <Text className="font-med text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.commission_consent_step.title"
                        defaultMessage="Acknowledge Introducer Commission"
                    />
                </Text>
            }
        />
    );
};
